export default __webpack_public_path__ + "static/media/1.71cc6d86.png";